import $ from 'jquery';
import {gsap} from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import {ScrollTrigger} from "gsap/ScrollTrigger";
import CustomAnimations from "src/scripts/modules/CustomAnimation";
import { isMobile } from 'detect-touch-device';

const bodyPage = document.body.getAttribute('data-page');
const animations = new CustomAnimations();
let smoother;

function closeNavigation() {
  var navMain = $("#navbarNav");
  navMain.collapse('hide');
}

function openFormular() {
  //alert('openFormular');
  $('.btn_open_form').addClass('deactive');
  $('.btn-text_kontaktform').html("&nbsp;&nbsp;&nbsp; Formular schließen &nbsp;&nbsp;&nbsp;");
  $( ".form_holder_contact" ).slideDown( "slow", function() {});
}

function closeFormular() {
  $('.btn_open_form').removeClass('deactive');
  $('.btn-text_kontaktform').html("Kontakt: Unternehmen");
  $( ".form_holder_contact" ).slideUp( "slow", function() {});
}


class ModuleNavigation {
  // Initialisierung der Navigation
  init() {
    this.initPage();
    this.initListener();
    this.onScroll();
    this.onResize();
  }

  initPage = () => {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin );

    const navLinks = document.querySelectorAll('.nav-link');

    navLinks.forEach(link => {
      const linkPage = link.getAttribute('data-page'); // `data-page` vom Link
      if (linkPage === bodyPage) {
        link.classList.add('active'); // Klasse "active" hinzufügen
      }
    });

    // Anpassung des Kontakt-Links
    const kontaktLink = document.querySelector('a[href="?f=1#kontakt"]');
    if (bodyPage === 'manager' && kontaktLink) {
      kontaktLink.setAttribute('href', 'index.html#kontakt');
      kontaktLink.removeClass('btn-scroll');
    }

    var hash = window.location.hash.substring(1);
    if(hash == 'kontakt')
    {
      openFormular();
    }
  };

  initListener = () => {

    $('.nav-link').click(function() {
      closeNavigation();
    });

    // open kontakt button
    $('.btn_open_form').click(function( event ) {
      event.preventDefault();

      if( $(this).hasClass('deactive') )
      {
        closeFormular();
      }
      else {
        openFormular();
      }
    });

    // scroll button
    $( '.btn-scroll' ).on( 'click', function( event )
    {
      event.preventDefault();

      closeNavigation();

      if( $(this).attr('href') == '#kontakt' && bodyPage === 'manager') {
        window.location.href = 'index.html#kontakt';
      }

      if($(this).attr('href') == '#kontakt'){
        openFormular();
      }


      if(!isMobile) {
        smoother = animations.getSmoother();
        smoother.scrollTo( $(this).attr('href'), true );
      }
      else {

        gsap.to(window, {
          duration: 2,
          ease: "power4.out",
          scrollTo:{
            y: $(this).attr('href'),
            //autoKill: false
          }
        })
      }
    });

    // nav button
    $('.nav-link').on( 'click', function( )
    {

    });

  };

  onResize = () => {
    $(window)
      .resize(() => {
      })
      .resize();
  };

  onScroll = () => {
    // Scroll-Event (mit Debouncing)
    $(window).scroll(() => {

      closeNavigation();

        // Dynamische Navigation verkleinern/vergrößern
        const navbar = $('.navbar');
        if (window.scrollY > 20) {
          navbar.addClass('small'); // Klasse hinzufügen
          //console.log('Navigation ist jetzt klein.');
        } else {
          navbar.removeClass('small'); // Klasse entfernen
          //console.log('Navigation ist jetzt groß.');
        }
    });
  };
}

export default ModuleNavigation;
